import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { API_ENDPOINTS } from '../constants/api.constant';
import { ApiResponse, MasterData } from '../models/api-response.model';

export type MasterDataPayload = Pick<MasterData, 'category' | 'code' | 'name' | 'description'>;

@Injectable({ providedIn: 'root' })
export class MasterDataService {
  private readonly http = inject(HttpClient);

  list(): Observable<ApiResponse<MasterData[]>> {
    return this.http.get<ApiResponse<MasterData[]>>(API_ENDPOINTS.masterData);
  }

  create(payload: MasterDataPayload): Observable<ApiResponse<MasterData>> {
    return this.http.post<ApiResponse<MasterData>>(API_ENDPOINTS.masterData, payload);
  }
}
